<template>
    <v-dialog  persistent  v-model="dialog" width="60%">
        <l-map    
            ref="geoMap"                    
            :zoom="zoom"                            
            :options="mapOptions"
            :bounds="bounds"
            style="min-height:450px;"                                      
            >                                          
            <l-tilelayer :url="url" :attribution="attribution"></l-tilelayer>      
            <v-layout row>
                <v-spacer></v-spacer>
                <v-btn style="position:relative; z-index:1600;" color="accent" @click="close"><i class="fas fa-times fa-2x"></i> </v-btn>                
            </v-layout>

        </l-map>        
    </v-dialog>
</template>

<script>
    import MapMixin from '../../plugins/mixins/MapMixin'
    import ColorMixin from '../../plugins/mixins/ColorMixin'
    export default {
        props:['geoZone'],
        mixins:[ MapMixin, ColorMixin ],
        data(){
            return {      
                dialog:true,
                zoneTypeFilters:{},
                showTypeFilters:false,
                mapType:"",          
                newMode: false,
                polyPoints: [],
                geoJson:null,
                polyPointColor: 'green',
            }
        },
        methods: {
            close(){
                this.$emit("close")
            }
        },
        mounted(){
            if(this.geoZone){
                let arr=[]
                this.geoZone.geopoly.coordinates[0].forEach((cr) => {
                    arr.push({"lng":cr[0], "lat":cr[1]})
                });
                this.polyPoints = arr

                let vm = this
                this.$nextTick(() => {            
                    vm.mapCenter = [52,6]
                    let map = vm.$refs['geoMap']          
                    let polygon = L.polygon(vm.polyPoints).addTo(map.mapObject)
                    vm.geoJSON = polygon.toGeoJSON()
                    //vm.squareMeasure = (area(this.geoJSON) ).toFixed(2)
                    //vm.lineDistance = (length(this.geoJSON, {units: 'kilometers'}).toFixed(2))
                    vm.bounds = vm.polyPoints
                    //vm.squareKm = (area(this.geoJSON) / 1000).toFixed(2);                            
                })               
            }             
        }             
    }
</script>

<style scoped>

</style>